import {
  background,
  space,
  color,
  layout,
  grid,
  alignItems,
  border,
  typography,
  flexWrap,
  flexDirection,
  justifyContent,
  flex,
  flexBasis,
  alignSelf,
  alignContent,
  gridTemplateRows,
  gridTemplateColumns,
  gridTemplateAreas,
  gridAutoFlow,
  gridArea,
  gridColumn,
  position,
  boxShadow,
} from 'styled-system';

import { theme } from './theme';

import styled from '@emotion/styled';
import { borderColor } from 'styled-system';
import { tintHexCode } from '../../../helpers/tintHexCode';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  ${space}
  ${layout}
    ${flex}
    ${flexDirection}
`;

export const Textarea = styled.textarea`
  ${space}
  ${color}
    ${typography}
    ${layout}
    ${border}
    resize: none;
  ${(props) =>
    props.default &&
    `
      font-size: 16px;
      padding: 10px 15px;
      color: #17324a;
      border-radius: 3px;
      border: 1px solid #5c7f92; 
      font-family: ${theme.fonts.sansSerif};
    `}
  &:read-only {
    border: 0px;
    padding: 0px;
  }
`;

export const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked {
      & + span {
        background-color: #bed600;
        &:before {
          -webkit-transform: translateX(15px);
          -ms-transform: translateX(15px);
          transform: translateX(15px);
          border: 1px solid #bed600;
          box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
        }
      }
    }
    &:focus {
      & + span {
        box-shadow: 0 0 1px #2196f3;
      }
    }
  }
  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 55px;
    box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.3);
    &:before {
      position: absolute;
      border-radius: 50%;
      content: '';
      height: 20px;
      width: 20px;
      left: 0px;
      bottom: 0px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border: 1px solid #ccc;
      box-sizing: border-box;
    }
  }
`;

export const StyledImg = styled.img`
  ${layout}
  ${space}
    ${(props) =>
    props.center &&
    `
      object-fit: cover;  
      object-position: center;  
    `}
`;
export const StyledTag = styled.span`
  ${space}
  ${color}
    ${typography}
    ${layout}
    ${alignSelf}
    ${border}
    ${flex}
    ${flexBasis}
`;

export const UnorderedList = styled.ul`
  list-style: none;
  width: 100%;
  display: grid;
  padding: 0;
  margin: 0;
  li {
    height: 40px;
    position: relative;
    font-size: ${(props) => props.fontSize};
    display: flex;
    align-items: center;
    span {
      letter-spacing: 0.05em;
      font-weight: 800;
      font-size: 16px;
      font-family: Plus Jakarta Sans, sans-serif;
    }
    &:hover {
      cursor: pointer;
    }
  }
  ${space}
  ${color}
  ${typography}
  ${gridTemplateColumns}
`;

export const Input = styled.input`
  padding: 0px;
  box-sizing: border-box;
  ${(props) =>
    props.default &&
    `
    padding: 10px 15px;
    color: #17324a;
    border-radius: 3px;
    border: 1px solid #5c7f92; 
  `}
  ${space}
  ${color}
  ${typography}
  ${layout}
  ${alignSelf}
  ${border}
  ${flex}
  ${flexBasis}
  &:focus {
    outline: none;
  }
`;

export const StyledCheckbox = styled.label`
  ${space}
  display: inline-flex;
  cursor: pointer;
  position: relative;
  input {
    height: 25px;
    width: 25px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid #e8e8e8;
    outline: none;
    transition-duration: 0.3s;
    cursor: pointer;
    &:checked {
      border: 1px solid;
      border-color: ${theme.colors.oliveDrab};
      & + span {
        &:before {
          content: '\\2713';
          display: block;
          text-align: center;
          color: ${theme.colors.oliveDrab};
          position: absolute;
          left: 0.7rem;
          top: 0.2rem;
        }
      }
    }
    &:active {
      border: 1px solid ${theme.colors.oliveDrab};
    }
  }
  span {
    margin-left: 10px;
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  flex-direction: column;
  ${space}
  ${color}
  ${typography}
  ${flex}
  ${gridArea}
  .input-container {
    width: 100%;
    position: relative;
    input {
      width: 100%;
      transition: all 0.3s ease-in-out;
      &:focus {
        outline: none;
        box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.1);
      }
      &:valid {
        & + div {
          svg {
            opacity: 1;
            fill: green;
          }
        }
      }
    }
    svg {
      opacity: 0;
      transition: all 0.3s ease-in-out;
      position: absolute;
      width: 15px;
      height: 15px;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    }
    & + span {
      margin-top: 10px;
    }
  }
  span {
    margin-bottom: 5px;
    color: black;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
  }
`;

export const Box = styled.div(
  {
    boxSizing: 'border-box',
    minWidth: 0,
  },
  border,
  borderColor,
  space,
  color,
  layout,
  alignItems,
  grid,
  gridArea,
  gridColumn,
  flex,
  justifyContent,
  position,
  boxShadow,
  background,
);

export const Flex = styled(Box)(
  {
    display: 'flex',
  },
  flex,
  flexWrap,
  flexDirection,
  alignItems,
  alignContent,
  justifyContent,
  gridArea,
  gridColumn,
  position,
  layout,
  background,
);

Flex.displayName = 'Flex';

export const Grid = styled(Box)`
  display: grid;
  ${(props) =>
    props.scroll &&
    `
        scroll-snap-type: x mandatory !important;
        scrollbar-width: none;
        scroll-padding: 0px 24px;
        padding: 4px 24px 20px;
        margin: 0px -24px;
        grid-auto-flow: column !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scroll-snap-type: x mandatory !important;        
        &::-webkit-scrollbar{
          display: none;
        }
      `}
  ${gridTemplateRows}
    ${gridTemplateColumns}
    ${gridTemplateAreas}
    ${gridAutoFlow}
    ${flex}
`;

Flex.displayName = 'Grid';

export const Heading = styled.h1(
  {
    margin: 0,
  },
  layout,
  color,
  space,
  typography,
  border,
  gridArea,
);

export const TextStyled = styled.p`
  ${space}
  ${color}
  ${typography}
  ${layout}
  ${border}
  ${(props) => props.uppercase && `text-transform: uppercase`}
`;

TextStyled.displayName = 'TextStyled';

export const LinkStyled = styled.a`
  color: grey;
  ${space}
  ${color}
  ${typography}
  ${layout}
  ${alignSelf}
  ${(props) => props.uppercase && `text-transform: uppercase`}
  text-decoration: none;
  transition: opacity 0.3s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
`;

export const OutlinedButton = styled.button`
  position: relative;
  width: 170px;
  height: 50px;
  border: 0;
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border: 2px solid ${theme.colors.lightGreen};
  color: ${theme.colors.lightGreen};
  text-align: center;
  padding: 12px 24px;
  line-height: 18px;
  font-size: 16px;
  font-weight: bold;
  transition: opacity 0.3s ease-in-out;
  background: ${theme.colors.white};
  text-transform: ${(props) => (props.uppercase ? `uppercase` : 'none')};
  ${background}
  ${space}
  ${border}
  ${color}
  ${typography}
  ${layout}
  ${flex}
  ${flexDirection}
  ${alignSelf}
  ${position}
  ${boxShadow}
  ${gridColumn}
  ${(props) =>
    props.as === 'a' &&
    `    
    text-decoration: none;                                         
  `}
  &:hover {
    cursor: pointer;
    background: ${(props) => props.bg};
    opacity: 0.9;
  }
`;

export const StyledButton = styled.button`
  position: relative;
  width: 200px;
  height: 50px;
  border: 0;
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  color: white;
  text-align: center;
  padding: 12px 24px;
  line-height: 18px;
  font-size: 14px;
  font-weight: bold;
  transition: 0.3s;
  background-color: ${theme.colors.primary};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  text-transform: ${(props) => (props.uppercase ? `uppercase` : 'none')};
  ${background}
  ${space}
  ${border}
  ${color}
  ${typography}
  ${layout}
  ${flex}
  ${flexDirection}
  ${alignSelf}
  ${position}
  ${boxShadow}
  ${gridColumn}
  ${(props) =>
    props.as === 'a' &&
    `    
    text-decoration: none;                                         
  `}
  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background: ${(props) => (props.disabled || props.noHover ? null : tintHexCode(theme.colors.primary))};
  }
`;

export const DynamicComponet = styled.div(space, color, layout, grid, alignItems);

export const Divider = styled.div`
  ${space}
  ${color}
  ${layout}
  ${theme}
`;

export const TextBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  ${space}
  ${color}
  ${layout}
  ${border}
  ${typography}
  ${gridArea}
`;

export const TitleWithText = styled.div`
  .title {
    margin: 0;
    font-size: 25px;
    color: #72a826;
  }
  p {
    color: #818181;
    font-size: 14px;
  }
  ${(props) => props.border && `border-bottom: 1px solid #eee`}
`;

export const StyledForm = styled.form`
  ${space}
  ${position}
  ${layout}
  ${flexDirection}
  label {
    display: flex;
    flex-direction: column;
    span {
      letter-spacing: 2px;
      color: white;
      font-size: 12px;
    }
    input {
      ${color}
      border: 0px;
      height: 40px;
      font-size: 16px;
      line-height: 32px;
      color: ${(props) => props.color};
      background: white;
    }
  }
`;
